// function initDropdownSelects() {
//   $('.select').each(function(i) {
//     initSelect($(this));
//   });
// }

export function initSelect(selectElem, onOpenCallback = null) {
  var $select = selectElem;
  var $choose = selectElem.find(".choose-item");
  
  // handle KEYPRESS events
  $("body").on("keypress", function(e) {
    var $target = $(e.target);
    var $parent = $target.parents(".select");
    if (e.which == 13) {
      if ($target.attr("name") == "item-type") {
        var $whichActive = $("#" + $choose.val());
        $whichActive.focus();
        $(".select").removeClass("active");
        
        var $clicked = $("input:checked ~ label");
        var clicked = $clicked.text();
        $choose.val($clicked.attr("for"));
        $choose.find('.item-text').text(clicked);
        $select.removeClass("active");
      } else {
        $select.removeClass("active");
      }
      $select.trigger('changedSelectVal');
    }
  });
  
  // handle random body clicks off-$target
  $("body").on("click", function (e) {
    var $target = $(e.target);
    var isSelect = $target.parents(".select").length > 0;
    if (!isSelect) {
      $select.removeClass("active");
    }
  });

  // handle direct BUTTON click
  $choose.on("click", function() {
    var $whichActive = $("#" + $choose.val());
    if ($select.hasClass("active")) {
      $select.removeClass("active");
      $choose.focus();
    } else {
      $select.addClass("active");
      $whichActive.focus();
    }
  });

  // handle direct LABEL clicks
  $select.on("click", "label", function() {
    var clicked = $(this).text();
    $choose.val($(this).attr("for"));
    $choose.find('.item-text').text(clicked);
    $select.removeClass("active");
    $select.trigger('selectActiveClassChanged');
    if (onOpenCallback) {
      onOpenCallback();
    }
    $select.trigger('changedSelectVal');
  });
}
